import * as React from 'react';
import {FormComponentProps} from "antd/lib/form";
import {Form} from "antd";
import * as moment from 'moment';
import locales from "../locales";
import SubmitCancelFormItem from "../common/form-items/SubmitCancelFormItem";
import DatePickerFormItem from "../common/form-items/DatePickerFormItem";
import {MOMENT_DATE_FORMAT} from "../utils/date-utils";

const FIELD_DELETE_DATE = 'deleteDate';

interface Props extends FormComponentProps {
  onFormSubmit: (deleteDate: moment.Moment) => void;
  onFormCancel: () => void;
}

class ItemDeleteForm extends React.Component<Props, {}> {

  public render() {
    const {form} = this.props;
    const deleteDate = moment();

    return (
      <Form>
        <DatePickerFormItem
          form={form}
          fieldId={FIELD_DELETE_DATE}
          label={locales.delete_date}
          initialValue={deleteDate}
          required={true}
          showTime={false}
          format={MOMENT_DATE_FORMAT}
        />
        <SubmitCancelFormItem
          submitButtonType="danger"
          submitLabel={locales.delete}
          onSubmit={this.onFormSubmit}
          onCancel={this.onFormCancel}
        />
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit(values[FIELD_DELETE_DATE]);
      }
    });
  };
}

export default Form.create<Props>()(ItemDeleteForm);



// WEBPACK FOOTER //
// ./src/item-details/ItemDeleteForm.tsx